import { render, staticRenderFns } from "./UserEditProfile.vue?vue&type=template&id=2cba0357&scoped=true"
import script from "./UserEditProfile.vue?vue&type=script&lang=js"
export * from "./UserEditProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cba0357",
  null
  
)

export default component.exports